import React from "react";

import { ReactComponent as RaisedHandIcon } from "../../assets/raised-hand-emoji.svg";

import "./Services.scss";

const Services = () => {
  return (
    <div className="services">
      <p>
        From Ideas to Impact: My Offerings{" "}
        <RaisedHandIcon className="svg-title-icon" />
      </p>
      <div className="content">
        <ul>
          <li>
            <span>Resume Revamp for Job Success: </span>
            Many resumes fail to stand out because they lack clarity, structure,
            or alignment with industry trends. I help transform your resume into
            a powerful marketing tool that highlights your strengths and grabs
            recruiters' attention.
          </li>
          <li>
            <span>Career Navigation Made Simple: </span>
            Career decisions can be overwhelming due to a lack of direction,
            market insights, or confidence. I provide personalized guidance to
            help you define your path and achieve your goals.
          </li>
          <li>
            <span>Mock Interviews for Real-World Success: </span>
            Many candidates fail interviews because they lack preparation or
            don’t know how to articulate their strengths. I offer tailored mock
            sessions with constructive feedback to ensure you’re fully ready for
            the real thing.
          </li>
          <li>
            <span>Crafting Future-Ready Web Apps: </span>
            Businesses often struggle with inefficient or outdated web
            applications that hinder growth. I develop modern, scalable
            solutions tailored to your unique needs, helping you stay ahead in
            the digital age.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Services;
